import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@styleseat/ui';
import { Touchable } from '../../ui';
import { BasicMenuIcon } from '../../ui/Icons';

import './SidebarToggle.module.scss';

/**
 * Displays a hamburger icon which, when pressed, toggles the sidebar open and closed.
 */
const DeprecatedSidebarToggle = ({ toggle }) => (
  <Touchable onClick={toggle} testID="sidebar-toggle">
    <Box
      width={40}
      height={40}
      alignItems="center"
      justifyContent="center"
    >
      <BasicMenuIcon />
    </Box>
  </Touchable>
);

DeprecatedSidebarToggle.propTypes = {
  /**
   * Function provided by redux to open and close the sidebar
   */
  toggle: PropTypes.func,
};

DeprecatedSidebarToggle.defaultProps = {
  toggle: () => {},
};

export default DeprecatedSidebarToggle;
